<template>
  <div>
    <Header :title="$t('wallet.title')" />
    <div class="full-page-box">
      <van-pull-refresh
        pulling-text="Sao chép nhanh quy trình thả xuống"
        loosing-text="Bản sao nhắc nhở của quá trình phát hành"
        loading-text="Đang tải bản sao nhắc quá trình"
        success-text="Làm mới bản sao lời nhắc thành công"
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <van-empty
          v-if="list.length === 0"
          :description="$t('wallet.empty_data')"
        />
        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="topInfo">
            <span v-if="v.status === 2" style="color: #07c160">{{
              v.status_text
            }}</span>
            <span v-else-if="v.status === 4" style="color: #07c160">{{
              v.status_text
            }}</span>
            <span v-else>{{ v.status_text }}</span>
            <span>{{ $t("wallet.money") }}：-{{ v.money }}</span>
          </div>
          <div class="desc">
            <span>{{ $t("wallet.desc") }}：{{ v.desc }}</span>
          </div>
          <div class="time">
            <span>{{ $t("wallet.submit_time") }}：{{ v.create_time }}</span>
          </div>
          <div class="time">
            <span>{{ $t("wallet.check_time") }}：{{ v.update_time }}</span>
          </div>
          <van-divider />
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>
  
  <script>
  import Header from "@/components/header/index.vue";
  import { Toast } from "vant";
export default {
  name: "WithdrawRecord",
  components: {  Header },
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        Toast(this.$t("wallet.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList() {
      this.$http({
        method: "get",
        url: "user_get_withdraw_list",
      }).then((res) => {
        if (res.code === 200) {
          this.list = res.data;
        } else if (res.code === 401) {
            Toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "login" });
    } else {
      this.getUserWithdrawList();
    }
  },
};
</script>
  
 <style scoped>


.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 1.8;
}

.item_list .topInfo span {
  flex: 1;
  font-weight: 700;
  color: #ff253f;
}
.item_list .time span {
  flex: 1;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child {
  float: right;
}
.item_list .desc span {
  font-weight: 700;
  color: #9b9b9b;
}
</style>
  